(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["thv-designers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('thv-designer-directory')) {
    customElements.define('thv-designer-directory', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const input = this.querySelector('input[type="search"]');
        const brands = [...this.querySelectorAll('[data-brand]')];
        const groups = [...this.querySelectorAll('[data-group]')];
        const buttons = [...this.querySelectorAll('[data-letter]')];
        const initials = new Set(brands.map(brand => brand.dataset.initial));
        let selected = 'all';
        const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
        const update = () => {
          const query = normalize(input.value);
          let count = 0;
          brands.forEach(brand => {
            brand.hidden = !(normalize(brand.dataset.brand).includes(query) && (selected === 'all' || brand.dataset.initial === selected));
            if (!brand.hidden) count++;
          });
          groups.forEach(group => { group.hidden = !group.querySelector('[data-brand]:not([hidden])'); });
          buttons.forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.letter === selected)); });
          this.querySelector('[data-result]').textContent = `${count} ${count === 1 ? 'designer' : 'designers'}`;
          this.querySelector('[data-empty]').hidden = count > 0;
        };
        buttons.forEach(button => {
          button.disabled = button.dataset.letter !== 'all' && !initials.has(button.dataset.letter);
          button.addEventListener('click', () => { selected = button.dataset.letter; input.value = ''; update(); });
        });
        input.addEventListener('input', () => { selected = 'all'; update(); });
        this.querySelector('[data-reset]').addEventListener('click', () => { selected = 'all'; input.value = ''; update(); input.focus(); });
        this.querySelectorAll('[data-enhanced]').forEach(element => { element.hidden = false; });
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
